import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const handleAccessibility = (e) => {
    e.preventDefault();
    document.querySelector('.asw-menu-btn')?.click();
  };

  return (
    <footer
      className="w-full flex flex-col md:flex-row justify-between items-center gap-6"
      style={{
        borderTop: '1px solid #1F1F1F',
        marginTop: '5rem',
        paddingTop: '5rem',
        paddingBottom: '4rem',
      }}
    >
      {/* Far Left: Social Links */}
      <div className="flex gap-8 tracking-[0.1em] text-[0.85rem] uppercase">
        <a
          href="https://www.youtube.com/@AaronFigueroa1"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#FFFFFF] hover:text-[#A0A0A0] transition-colors duration-300"
        >
          YOUTUBE
        </a>
        <a
          href="https://www.instagram.com/aaron.figueroa_"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#FFFFFF] hover:text-[#A0A0A0] transition-colors duration-300"
        >
          INSTAGRAM
        </a>
      </div>

      {/* Center: Copyright & Legal */}
      <div className="flex flex-wrap justify-center items-center gap-3 text-[0.75rem] uppercase tracking-[0.1em] text-[#666666]">
        <span>© 2026 AARON FIGUEROA</span>
        <span>•</span>
        <Link
          to="/privacy"
          className="transition-colors duration-300 hover:text-[#FFFFFF]"
        >
          PRIVACY
        </Link>
        <span>•</span>
        <a
          href="#"
          onClick={handleAccessibility}
          className="transition-colors duration-300 hover:text-[#FFFFFF]"
        >
          ACCESSIBILITY
        </a>
      </div>

      {/* Far Right: CTA */}
      <Link
        to="/contact"
        className="text-[0.85rem] uppercase tracking-[0.1em] text-[#FFFFFF] hover:text-[#A0A0A0] transition-colors duration-300"
      >
        GET IN TOUCH
      </Link>
    </footer>
  );
}